import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import toast from "react-hot-toast";
import { ROLES, PROJECT_ROLES,APPLICATION_ROLES,USER_LIST } from "services/endPoints";
import { privateRequest } from "services/privateRequest";

const initialState = {
  roleList: [],
  projectsRoleList: [],
  applicationRoleList: [],
  cloneRoleList: [],
  cloneRoleLoading: false,
  cloneRoleTotalCount: 0,
  applicationtotalCount: 0,
  applicationLoading: false,
  totalCount: 0,
  loading: false,
  getalluserList : [],
  userListLoading : false,
  userListTotalCount : 0,
};

export const getRole = createAsyncThunk("entity/getRole", async () => {
  const res = await privateRequest.get(ROLES);
  return {
    data: res?.data?.data || [],
  };
});

const parseRoleListResponse = (res) => {
  const responseData = res?.data?.data || {};
  const data = responseData.data || [];
  const count = responseData.count || {};
  const total =
    count?.total ??
    responseData.totalCount ??
    responseData.total ??
    (typeof count === "number" ? count : 0);

  return {
    data,
    count: { total },
  };
};

export const getProjectsRoleListPage = createAsyncThunk(
  "entity/getProjectsRoleListPage",
  async ({ pageNo = 1, pageSize = 10, search = "", projectId }) => {
    const res = await privateRequest.get(PROJECT_ROLES, {
      params: { pageNo, pageSize, search },
      headers: projectId ? { "project-id": projectId } : {},
    });
    return parseRoleListResponse(res);
  }
);

export const getApplicationRoleList = createAsyncThunk(
  "entity/getApplicationRoleList",
  async ({ pageNo = 1, pageSize = 10, search = "", append: _append, ...rest }) => {
    const res = await privateRequest.get(APPLICATION_ROLES, {
      params: { pageNo, pageSize, search, ...rest },
    });
    return parseRoleListResponse(res);
  }
);

export const addRole = createAsyncThunk(
  "entity/addRole",
  async (payload, { dispatch, rejectWithValue }) => {
    try {
    const res = await privateRequest.post(ROLES, payload);
    if (res) {
      toast?.success?.(res?.data?.message);
    }
    return {
      data: res?.data?.data || [],
    };
  } catch (error) {
    toast?.error?.(error?.response?.data?.message || "Failed to add role.");
    return rejectWithValue(error?.response?.data);
  }
});

export const editRole = createAsyncThunk(
  "entity/editRole",
  async ({ payload, id }, { dispatch, rejectWithValue }) => {
    try {
    const res = await privateRequest.put(ROLES + "/" + id, payload);
    if (res) {
      toast?.success?.(res?.data?.message);
    }
    return {
      data: res?.data?.data || [],
    };
    } catch (error) {
      toast?.error?.(error?.response?.data?.message || "Failed to edit role.");
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const deleteRole = createAsyncThunk(
  "entity/deleteRole",
  async ( id , { dispatch, rejectWithValue }) => {
    try {
    const res = await privateRequest.delete(ROLES + "/" + id);
    if (res) {
      toast?.success?.(res?.data?.message);
    }
    return {
      data: res?.data?.data || [],
    };
    } catch (error) {
      toast?.error?.(error?.response?.data?.message || "Failed to delete role.");
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const getCloneRoleList = createAsyncThunk(
  "role/getCloneRoleList",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await privateRequest.get(
        payload.scope === "GLOBAL"
          ? APPLICATION_ROLES
          : PROJECT_ROLES,
        // {
        //   params: {
        //     pageNo: payload.pageNo,
        //     pageSize: payload.pageSize,
        //     search: payload.search || "",
        //   },
        // }
      );

      return {
        data: response?.data?.data?.data || [],
        totalCount: response?.data?.data?.totalCount || 0,
        pageNo: payload.pageNo,
      };
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const getAllUsers = createAsyncThunk(
  "role/getAllUsers",
  async ( params , { rejectWithValue }) => {
    try {
      const { append: _append, ...apiParams } = params || {};
      const response = await privateRequest.get(USER_LIST, { params: apiParams });
      return {
        data: response?.data?.data?.data || [],
        totalCount: response?.data?.data?.count?.total || 0,
        pageNo: apiParams["page-no"] || apiParams.pageNo,
      } 
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const getByUserId = createAsyncThunk(
  "role/getByUserId",
  async ( id , { rejectWithValue }) => {
    try {
      const response = await privateRequest.get(`api/users/${id}`);
      return {
        data: response?.data?.data || {},
      } 
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const deleteUser = createAsyncThunk(
  "role/deleteUser",
  async ( id , { rejectWithValue }) => {
    try {
    const res = await privateRequest.delete(`api/users/${id}`);
    if (res) {
      toast?.success?.(res?.data?.message);
    }
    return {
      data: res?.data?.data || [],
    };
    } catch (error) {
      toast?.error?.(error?.response?.data?.message || "Failed to delete user.");
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const editUser = createAsyncThunk(
  "role/editUser",
  async ({ payload, id }, { rejectWithValue }) => {
    try {
    const res = await privateRequest.put(`api/users/${id}`, payload);
    if (res) {
      toast?.success?.(res?.data?.message);
    }
    return {
      data: res?.data?.data || [],
    };
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to edit user.");
      return rejectWithValue(error?.response?.data);
    }
  }
);


const roleSlice = createSlice({
  name: "role",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getRole.fulfilled, (state, action) => {
        state.roleList = action.payload.data;
      })
      .addCase(getProjectsRoleListPage.pending, (state, action) => {
        state.loading = true;
        const pageNo = action.meta?.arg?.pageNo || 1;
        const shouldAppend = action.meta?.arg?.append && pageNo > 1;
        if (!shouldAppend) {
          state.projectsRoleList = [];
        }
      })
      .addCase(getProjectsRoleListPage.fulfilled, (state, action) => {
        const pageNo = action.meta?.arg?.pageNo || 1;
        const shouldAppend = action.meta?.arg?.append && pageNo > 1;
        const data = action.payload.data;

        if (shouldAppend) {
          state.projectsRoleList = [...state.projectsRoleList, ...data];
        } else {
          state.projectsRoleList = data;
        }

        state.totalCount = action.payload.count?.total;
        state.loading = false;
      })
      .addCase(getProjectsRoleListPage.rejected, (state) => {
        state.loading = false;
      })
      .addCase(getApplicationRoleList.pending, (state, action) => {
        state.applicationLoading = true;
        const pageNo = action.meta?.arg?.pageNo || 1;
        const shouldAppend = action.meta?.arg?.append && pageNo > 1;
        if (!shouldAppend) {
          state.applicationRoleList = [];
        }
      })
      .addCase(getApplicationRoleList.fulfilled, (state, action) => {
        const pageNo = action.meta?.arg?.pageNo || 1;
        const shouldAppend = action.meta?.arg?.append && pageNo > 1;
        const data = action.payload.data;

        if (shouldAppend) {
          state.applicationRoleList = [...state.applicationRoleList, ...data];
        } else {
          state.applicationRoleList = data;
        }

        state.applicationtotalCount = action.payload.count?.total;
        state.applicationLoading = false;
      })
      .addCase(getApplicationRoleList.rejected, (state) => {
        state.applicationLoading = false;
      })
      .addCase(getCloneRoleList.pending, (state) => {
        state.cloneRoleLoading = true;
      })

      .addCase(getCloneRoleList.fulfilled, (state, action) => {
        state.cloneRoleLoading = false;
        const { data, totalCount } = action.payload;

        state.cloneRoleTotalCount = totalCount;
        state.cloneRoleList = data;
      })

      .addCase(getCloneRoleList.rejected, (state) => {
        state.cloneRoleLoading = false;
      })
      .addCase(getAllUsers.pending, (state) => {
        state.userListLoading = true;
      })
      .addCase(getAllUsers.fulfilled, (state, action) => {
        state.userListLoading = false;
        const { data, totalCount } = action.payload;
        const pageNo = action.meta?.arg?.["page-no"] || 1;
        const shouldAppend = action.meta?.arg?.append && pageNo > 1;

        if (shouldAppend) {
          state.getalluserList = [...state.getalluserList, ...data];
        } else {
          state.getalluserList = data;
        }
        state.userListTotalCount = totalCount;
      })
      .addCase(getAllUsers.rejected, (state) => {
        state.userListLoading = false;
      });
  },
});

export default roleSlice.reducer;
export const {} = roleSlice.actions;
